import { useCallback } from "react";

import noop from "lodash/noop";
import { List } from "react-virtualized";

import { Button } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { EMPTY_STATE_BANNER_BTN_TEXT } from "app/pages/activation/components/EmptyStateBunner/texts";
import { DEFAULT_LIST_WIDTH, LIST_HEIGHT, LIST_ROW_HEIGHT } from "app/pages/activation/components/ProjectsList/constants";
import { statesDataAutomation } from "app/pages/activation/components/ProjectsList/dataAutomationKeys";
import { Item } from "app/pages/activation/components/ProjectsList/Item/Item";
import { IconsMock } from "app/pages/activation/components/ProjectsList/States/__mock__/iconsMock";
import { PROJECTS_LIST_MOCK } from "app/pages/activation/components/ProjectsList/States/__mock__/projectsListMock";

import * as SC from "./styles";

type EmptyProjectsListSchema = {
    onClick: () => void;
    listWidth?: number;
};

export const EmptyProjectsList = ({ onClick, listWidth }: EmptyProjectsListSchema) => {
    const ListRender = useCallback(({ index, key, style }) => {
        const project = PROJECTS_LIST_MOCK[index];
        const icons = [...IconsMock];
        icons.length = project.allDomains.length;

        return (
            <div
                style={style}
                key={key}
            >
                <Item
                    onConnectGa={noop}
                    project={project}
                    isLoading={false}
                    icons={icons}
                />
            </div>
        );
    }, []);

    return (
        <SC.Container data-automation={statesDataAutomation.empty}>
            <List
                width={listWidth ?? DEFAULT_LIST_WIDTH}
                height={LIST_ROW_HEIGHT * PROJECTS_LIST_MOCK.length}
                rowHeight={LIST_ROW_HEIGHT}
                rowCount={PROJECTS_LIST_MOCK.length}
                rowRenderer={ListRender}
                data-automation={statesDataAutomation.emptyList}
                onScroll={noop}
                containerStyle={{ minHeight: `${LIST_HEIGHT}px` }}
            />

            <SC.ButtonContainer>
                <Button
                    onClick={onClick}
                    type="primary"
                    dataAutomation={statesDataAutomation.emptyButton}
                >
                    {translate(EMPTY_STATE_BANNER_BTN_TEXT)}
                </Button>
            </SC.ButtonContainer>
        </SC.Container>
    );
};
